import { RefObject } from "react";

import { useEventListener } from "usehooks-ts";

type THandler = (event: MouseEvent) => void;

export function useOnClickOutside<T extends HTMLElement = HTMLElement>(
  refs: RefObject<T>[],
  handler: THandler,
  mouseEvent: "mousedown" | "mouseup" = "mousedown",
): void {
  useEventListener(mouseEvent, (event) => {
    const isOutsideRefs = refs
      .map((ref) => !ref.current?.contains(event.target as Node))
      .every((value) => !!value);

    if (isOutsideRefs) handler(event);
  });
}
